 export default ( ) => ({
    eventosActivos: [], tribunas: [], localidades: [], numPalcos: []
 })